module.exports = {
	"_args": [
		[
			"draft-convert@1.4.8",
			"C:\\Users\\Bobby Yang\\projects\\blitz-cms-frontend"
		]
	],
	"_from": "draft-convert@1.4.8",
	"_id": "draft-convert@1.4.8",
	"_inBundle": false,
	"_integrity": "sha1-dHQKzjaJeVOb0nt0GNmQHgZ+8m8=",
	"_location": "/draft-convert",
	"_phantomChildren": {},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "draft-convert@1.4.8",
		"name": "draft-convert",
		"escapedName": "draft-convert",
		"rawSpec": "1.4.8",
		"saveSpec": null,
		"fetchSpec": "1.4.8"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/draft-convert/-/draft-convert-1.4.8.tgz",
	"_spec": "1.4.8",
	"_where": "C:\\Users\\Bobby Yang\\projects\\blitz-cms-frontend",
	"author": {
		"name": "bbriggs@hubspot.com"
	},
	"bugs": {
		"url": "https://github.com/HubSpot/draft-convert/issues"
	},
	"dependencies": {
		"immutable": "~3.7.4",
		"invariant": "^2.2.1"
	},
	"description": "Extensibly serialize & deserialize Draft.js ContentState",
	"devDependencies": {
		"babel-cli": "^6.10.1",
		"babel-core": "^6.7.7",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^18.0.0",
		"babel-loader": "^6.2.4",
		"babel-preset-es2015": "^6.6.0",
		"babel-preset-react": "^6.5.0",
		"cross-env": "^3.1.4",
		"draft-js": "^0.8.1",
		"eslint": "3.12.0",
		"eslint-config-hubspot": "^7.0.0",
		"eslint-plugin-react": "6.8.0",
		"jasmine": "^2.2.0",
		"jest": "^18.1.0",
		"json-loader": "^0.5.4",
		"karma": "^0.13.22",
		"karma-chrome-launcher": "^0.2.3",
		"karma-jasmine": "^0.3.8",
		"karma-webpack": "^1.7.0",
		"react": "^15.4.2",
		"react-dom": "^15.4.2",
		"rimraf": "2.5.4",
		"webpack": "^1.13.0"
	},
	"files": [
		"dist",
		"lib"
	],
	"homepage": "https://github.com/HubSpot/draft-convert#readme",
	"jest": {
		"testRegex": "/test/spec/.*\\.js$"
	},
	"keywords": [
		"draft",
		"draftjs",
		"draft-convert",
		"convert"
	],
	"license": "Apache-2.0",
	"main": "lib/index.js",
	"name": "draft-convert",
	"peerDependencies": {
		"draft-js": ">=0.7.0",
		"react": "^15.0.2",
		"react-dom": "^15.0.2"
	},
	"repository": {
		"type": "git",
		"url": "git+https://github.com/HubSpot/draft-convert.git"
	},
	"scripts": {
		"build": "npm run build:commonjs && npm run build:umd && npm run build:umd:min",
		"build-and-test": "npm run clean && npm run build && npm run test-once",
		"build:commonjs": "cross-env BABEL_ENV=commonjs babel src --out-dir lib",
		"build:umd": "webpack --config webpack.config.development.js ./src/index.js ./dist/draft-convert.js",
		"build:umd:min": "webpack --config webpack.config.production.js ./src/index.js ./dist/draft-convert.min.js",
		"clean": "rimraf ./dist && rimraf ./lib",
		"jest": "jest",
		"jest-debug": "node --debug-brk --inspect ./node_modules/.bin/jest -i",
		"lint": "eslint src/ test/",
		"prepublish": "npm run lint && npm run build-and-test",
		"test": "npm run jest",
		"test-once": "npm run jest",
		"test-once:karma": "karma start test/karma.config.js --single-run",
		"test:karma": "karma start test/karma.config.js"
	},
	"version": "1.4.8"
};


//////////////////
// WEBPACK FOOTER
// ./~/draft-convert/package.json
// module id = 1039
// module chunks = 0